/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash f2b65e9b142afbb21275ce56954c9a36 */

import { ConcreteRequest } from "relay-runtime";

export type recaptchaFeatureFlagQueryVariables = {
    featureFlag?: string | null | undefined;
    featureFlagV3?: string | null | undefined;
    hasFeatureFlag: boolean;
    hasFeatureFlagV3: boolean;
};
export type recaptchaFeatureFlagQueryResponse = {
    readonly viewer: {
        readonly featureFlag?: boolean | null | undefined;
        readonly v3Enabled?: boolean | null | undefined;
    };
};
export type recaptchaFeatureFlagQuery = {
    readonly response: recaptchaFeatureFlagQueryResponse;
    readonly variables: recaptchaFeatureFlagQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "featureFlag"
        } as any,
        {
            "defaultValue": "",
            "kind": "LocalArgument",
            "name": "featureFlagV3"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hasFeatureFlag"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hasFeatureFlagV3"
        } as any
    ], v1 = {
        "condition": "hasFeatureFlag",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "feature",
                        "variableName": "featureFlag"
                    }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": null
            }
        ]
    } as any, v2 = {
        "condition": "hasFeatureFlagV3",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "v3Enabled",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "feature",
                        "variableName": "featureFlagV3"
                    }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": null
            }
        ]
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "recaptchaFeatureFlagQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        (v2 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "RootQueryType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "recaptchaFeatureFlagQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        (v1 /*: any*/),
                        (v2 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/recaptchaFeatureFlagQuery",
            "metadata": {},
            "name": "recaptchaFeatureFlagQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '07775b1161f29c61d79976d0c04c520d';
export default node;
